import { Link, Modal, Spacer, Text } from '@loomhq/lens';
import React, { useState } from 'react';

import * as analytics from 'utilities/analytics';

import ConnectButtons from '../connect-buttons';
import EmailSignupForm from '../email-signup-form';
import { SIGNUP_PAGE_MODE_TOGGLED } from '../../../constants/events';

import styles from './styles.module.less';

function ModeSwitcher(props) {
  const { setSignupMode, signupMode } = props;

  return (
    <>
      <Spacer top={3} />
      <Text>
        {signupMode ? 'Already have an account? ' : 'Need an account? '}
        <Link
          className={styles.loomSignupLinkWrapper}
          onClick={() => {
            setSignupMode(!signupMode);

            analytics.track(SIGNUP_PAGE_MODE_TOGGLED, {
              signupMode,
            });
          }}
        >
          {signupMode ? 'Sign In' : 'Sign up for free'}
        </Link>
      </Text>
    </>
  );
}

function SignupOverlay(props) {
  const { show, onDismiss, afterAuthCallback } = props;
  const [signupMode, setSignupMode] = useState(true);
  const [emailFormExpanded, setEmailFormExpanded] = useState(false);

  const title = signupMode ? 'Sign up to download' : 'Sign in to download';
  const secondaryTitle = `or sign ${signupMode ? 'up' : 'in'} with email`;

  return (
    <Modal
      isOpen={show}
      onCloseClick={onDismiss}
      onBackgroundClick={onDismiss}
      maxWidth={48}
    >
      <div className={styles.loomSignupOverlay}>
        {!emailFormExpanded && (
          <>
            <Text size="xlarge" fontWeight="semiBold">
              {title}
            </Text>
            <Spacer top={3} />
            <ConnectButtons
              isSignUp={signupMode}
              overlayMode={true}
              afterAuthCallback={afterAuthCallback}
            />
            <Spacer top={3} />
            <div className={styles.loomSignupSecondaryTitle}>
              <hr />
              <Spacer left={1} />
              <Text fontWeight="semiBold" color="grey5">
                {secondaryTitle}
              </Text>
              <Spacer right={1} />
              <hr />
            </div>
          </>
        )}
        <EmailSignupForm
          isSignUp={signupMode}
          overlayMode={true}
          expanded={emailFormExpanded}
          expansionHandler={setEmailFormExpanded}
        />
        {!emailFormExpanded && (
          <ModeSwitcher signupMode={signupMode} setSignupMode={setSignupMode} />
        )}
      </div>
    </Modal>
  );
}

export default SignupOverlay;
